export default __webpack_public_path__ + "1fe7f82f5984d6ba0bf5508765f43021.png";